import {createSlice} from '@reduxjs/toolkit'

const termsCondition = createSlice({
  name: 'termsCondition',
  initialState: {
    isOpened: false,
  },

  reducers: {
    setTermsConditionState: (state, {payload}) => {
      if (payload?.show_terms_modal === 'yes') state.isOpened = true
      else if (payload?.show_terms_modal === 'no') state.isOpened = false
    },
    clearTermsConditionState: state => {
      state.isOpened = false
    },
  },
})

export const {setTermsConditionState, clearTermsConditionState} = termsCondition.actions
export default termsCondition
